/**
 * Dropdown
 * Wrapper for bootstrap Dropdown feature
 * @package feature/dropdown
 */

import { Dropdown } from 'bootstrap.native';
 
export class Dropable {
    constructor (element) {
        element.Dropable = this;

        // References
        this._refs = {
            el: element,
            opener: element.querySelector('a'),
            menu: element.querySelector('.dropdown-menu'),
            items: Array.from(element.querySelectorAll('.dropdown-menu a'))
        };

        // Events
        if(this._refs.opener != null) {
            this._refs.opener.addEventListener('click', this._onLinkClick.bind(this));
        }

        this._refs.items.forEach(item => item.addEventListener('click' , () => this._refs.menu.classList.remove('is-active')));
    }

    /**
     * onLinkClick
     * Show a dropdown if user has clicked on trigger (link)
     * @param {Event} e - Event interface
     */
    _onLinkClick (e) {
        const handler = (e) => {
            const base = this._refs.el;
            if(!base.contains(e.target)) {
                this._refs.menu.classList.remove('is-active');    
                document.removeEventListener('click', handler);
            }
        };

        if(this._refs.menu.classList.contains('is-active')) {
            this._refs.menu.classList.remove('is-active');
            document.removeEventListener('click', handler);
        } else {
            this._refs.menu.classList.add('is-active');
            document.addEventListener('click', handler);
        }
    }
}